import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { ListItemRegionTileFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { assertTypeName } from "../../client/guards";
import { stripHtmlTags } from "../../rich-text/utils";
import { RegionTile } from "../../regions/RegionTile";

type Props = {
  fragment: ListItemRegionTileFragment;
  listItemAttributeId: string;
  textAttributeId: string;
  children: React.ReactNode;
  dispatch: Dispatch<EditorAction>;
};

export function ListItemRegionTile({
  fragment,
  listItemAttributeId,
  textAttributeId,
  children,
  dispatch,
}: Props) {
  const { t } = useTranslation();

  const listItemAttribute = fragment.attributes.find(
    (a) => a.id === listItemAttributeId,
  );
  assertTypeName(listItemAttribute?.__typename === "ListItemAttribute");

  const textAttribute = fragment.attributes.find(
    (a) => a.id === textAttributeId,
  );
  assertTypeName(textAttribute?.__typename === "TextAttribute");

  const onClick = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "update",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTile
      fragment={fragment}
      preview={t("ListItemRegionTile.preview", {
        position: listItemAttribute.ordinal,
        text: stripHtmlTags(textAttribute.text),
      })}
      onClick={onClick}
    >
      {children}
    </RegionTile>
  );
}
